import React, { useEffect, useState } from "react";
import { Row, Col, Button, Spinner } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import MultiSelectInput from "../../custom/components/MultiSelect-Input/MultiSelectInput";
import { useParams } from "react-router-dom";
import {
  dropdownData,
  exportToExcel,
  formatDate,
  formatNumber,
  getRecords,
} from "../../services/api.service";
import SelectInput from "../../custom/components/Select-Input/SelectInput";

const OrderTracking = () => {
  const headerName = "Order Tracking";
  const { id } = useParams;
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState([]);
  const [ProjectSelect, setProjectSelect] = useState("");
  const [projectSelectOptions, setProjectSelectOptions] = useState([]);
  let [orderSelect, setOrderSelect] = useState("");
  const [orderSelectOptions, setOrderSelectOptions] = useState([]);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [projectError, setProjectError] = useState(false);
  const [orderError, setOrderError] = useState(false);
  const [itemError, setItemError] = useState(false);
  const [warehouseStockTableData, setWarehouseStockTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [groupedItems, setGroupedItems] = useState({});
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    getProjectDropData();
  }, []);
  let serialNumber = 1;

  useEffect(() => {
    if (ProjectSelect && orderSelect) {
      handleGo();
    }
  }, [searchKeyword]);

  const getProjectDropData = async () => {
    try {
      let payload = {
        modelName: "projects",
        whereCondition: {
          is_active: true,
        },
      };
      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "project_name"
        );
        setProjectSelectOptions(dropdownResponseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const getOrderDropData = async (projectId) => {
    try {
      let payload = {
        modelName: "orders",
        whereCondition: {
          is_active: true,
          project_id: projectId,
        },
      };
      const responseData = await getRecords(payload, "/getRecords");
      if (responseData.data && responseData.data.length > 0) {
        const dropdownResponseData = await dropdownData(
          responseData.data,
          "order_no"
        );
        const flattenedOptions = dropdownResponseData.reduce((acc, item) => {
          return acc.concat(item.options);
        }, []);

        setOrderSelectOptions([
          { value: "select-all", label: "Select All" },
          ...flattenedOptions,
        ]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleProjectSelect = (options) => {
    const selectedValue = options ? options.value : null;
    setProjectSelect(options);
    setSearchKeyword("");
    setOrderSelect("");
    setOrderSelectOptions([]);

    setWarehouseStockTableData([]);
    setFormData([]);
    setGroupedItems({});

    if (selectedValue) {
      setProjectError(false);
      getOrderDropData(selectedValue);
    } else {
      setProjectError(true);
    }
  };

  const handleOrderSelect = (options) => {
    if (!options || options?.length === 0) {
      setOrderSelect("");

      setWarehouseStockTableData([]);
      setFormData([]);
      setGroupedItems({});

      setOrderError(true);
      return;
    }

    if (options && options?.some((option) => option?.value === "select-all")) {
      const orderSelectFilterdOption = orderSelectOptions.filter(
        (option) => option.value !== "select-all"
      );
      setOrderSelect(orderSelectFilterdOption);

      setOrderError(false);
    } else {
      setOrderSelect(options);

      setOrderError(false);
    }
  };

  const handleGo = async () => {
    if (!ProjectSelect || !orderSelect) {
      setProjectError(!ProjectSelect ? true : false);
      setOrderError(!orderSelect ? true : false);
      return;
    }
    const o_id = orderSelect?.map((opt) => opt?.value);

    try {
      const payload = {
        order_id: o_id || [],
      };
      setLoading(true);
      const responseData = await getRecords(payload, "/listOrderTracking");

      if (responseData && responseData?.data) {
        //  responseData.data=responseData?.data.filter((data)=>data.stock_qty)

        const ordersItems =
          responseData &&
          responseData?.data?.map((item) => ({
            item_id: item?.item_id,
            order_no: item?.order_no,
            item_code: item?.make_item_code,
            buy_item_code: item.buy_item_code,
            order_date: item.order_date,
            order_qty: item.order_qty,
            inward_qty: item.inward_qty,
            outward_qty: item.outward_qty,
            installation_qty: item.installation_qty,
            invoice_qty: item.invoice_qty,
            commission_qty: item.commission_qty,
            installation_claimed_qty: item.installation_claimed_qty,
            installation_paid_qty: item.installation_paid_qty,
            commissioning_claim_qty: item.commissioning_claim_qty,
            commissioning_paid_qty: item.commissioning_paid_qty,
            type: item?.make_item_type,
          }));

        setFormData(ordersItems);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const FloatValue = (value) => {
    return parseFloat(value) || 0;
  };

  const filteredItems =
    !searchQuery || searchQuery.trim() === ""
      ? formData || []
      : formData?.filter((item) => {
          const query = searchQuery.toLowerCase().trim();
          return (
            item?.item_code?.toLowerCase().includes(query) ||
            item?.buy_item_code?.toLowerCase().includes(query)
          );
        }) || [];
  useEffect(() => {
    if (!filteredItems || filteredItems.length === 0) {
      setGroupedItems({});
    }

    const grouped = filteredItems.reduce((acc, item) => {
      if (!acc[item.item_code]) {
        acc[item.item_code] = {
          makeItem: { ...item, unique_id: `${item.item_code}-${item.id}` },
          buyItems: [],
        };
      }

      if (item.buy_item_code) {
        acc[item.item_code].buyItems.push({
          ...item,
          unique_id: `${item.buy_item_code}-${item.id}`,
        });
      }

      return acc;
    }, {});

    setGroupedItems(grouped);
  }, [filteredItems]);
  const handleExportData = () => {
    let serialNo = 1;
    const exportData = Object.values(groupedItems).flatMap((group) => {
      const makeItemData =
        group.makeItem.type == 1
          ? [
              {
                "Sr. No": serialNo,
                "SO No": group.makeItem.order_no || "N/A",
                "Item Code": group.makeItem.item_code || "N/A",
                "Order Date": "-",
                "Order QTY": "-",
                "Invoice QTY": "-",
                "Inward QTY": "-",
                "Outward QTY": "-",
                "Installation QTY": "-",
                "Installation Claimed QTY": "-",
                "Installation Paid QTY": "-",
                "commission QTY": "-",
                "Commissioning Claim QTY": "-",
                "Commissioning Paid QTY": "-",
              },
            ]
          : [];

      const buyItemsData = group.buyItems.map((item, subIndex) => ({
        "Sr. No":
          group.makeItem.type == 1 ? `${serialNo}.${subIndex + 1}` : serialNo,
        "SO No": item.order_no || "N/A",
        "Item Code": item?.buy_item_code || "N/A",
        "Order Date": item?.order_date,
        "Order QTY": item?.order_qty,
        "Invoice QTY": item?.invoice_qty,
        "Inward QTY": item?.inward_qty,
        "Outward QTY": item?.outward_qty,
        "Installation QTY": item?.installation_qty,
        "Installation Claimed QTY": item?.installation_claimed_qty,
        "Installation Paid QTY": item?.installation_paid_qty,
        "commission QTY": item?.commission_qty,
        "Commissioning Claim QTY": item?.commissioning_claim_qty,
        "Commissioning Paid QTY": item?.commissioning_paid_qty,
      }));

      serialNo++;

      return [...makeItemData, ...buyItemsData, {}];
    });

    exportToExcel(exportData, "orderTrackingReport.xlsx");
  };
  return (
    <CustomForm
      title={headerName}
      loadingData={loadingData}
      id={id}
      noBackButton={true}
      noSubmitButton={true}
    >
      <Row>
        <Col md={4}>
          <SelectInput
            label="Project"
            value={ProjectSelect}
            options={projectSelectOptions}
            onSelect={(selected) => handleProjectSelect(selected)}
            placeholder="Select Project"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={(projectError && "Please select a Project.") || ""}
          />
        </Col>

        <Col md={4}>
          <MultiSelectInput
            label="SO No"
            value={orderSelect}
            options={orderSelectOptions}
            onMultiSelect={(selected) => handleOrderSelect(selected)}
            placeholder="Select SO No"
            labelClassName="form-label"
            isClearable={true}
            asterisk={true}
            customError={(orderError && "Please select a SO No.") || ""}
          />
        </Col>

        <Col md={1} style={{ marginTop: "28px", paddingBottom: "20px" }}>
          <Button
            onClick={handleGo}
            color="primary"
            type="button"
            className="waves-effect waves-light me-1"
            style={{ background: "#006eb9" }}
          >
            Go
          </Button>
        </Col>
      </Row>

      <Row className="justify-content-center mt-4">
        <Col
          style={{
            marginBottom: "0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h6
              style={{
                fontSize: "16px",
                fontWeight: "600",
                color: "#333",
                backgroundColor: "#f8f9fa",
                padding: "10px 20px",
                borderRadius: "8px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                display: "inline-block",
                margin: "0px",
              }}
            >
              Item Details
            </h6>
          </div>

          <div className="d-flex gap-3">
            <div>
              <div className="app-search d-flex d-lg-inline mt-0 w-25">
                <div className="position-relative">
                  <input
                    type="search"
                    className="form-control ps-5"
                    placeholder="Search by item code.."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      width: "13rem",
                      padding: "8px 15px",
                      borderRadius: "8px",
                      borderColor: "#D2D2D2",
                      outline: "none",
                      transition: "all 0.3s ease",
                      boxShadow: "none",
                      marginRight: "0.5rem",
                    }}
                  />
                  <span className="ri-search-line"></span>
                </div>
              </div>
            </div>

            <div>
              <Button
                color="success"
                className="waves-effect waves-light me-1 mb-2"
                style={{ borderRadius: "50%" }}
                onClick={handleExportData}
              >
                <i class="fas fa-download"></i>
              </Button>
            </div>
          </div>
        </Col>
        <div
          className="table mt-2"
          style={{
            overflowX: "auto",
            overflowY: "auto",
            maxHeight: "500px",
            width: "100%",
            scrollBehavior: "smooth",
            scrollbarWidth: "thin",
            msOverflowStyle: "none",
            zIndex: 0,
          }}
        >
          <table className="table table-hover">
            <thead
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "#8AC1E8",
                zIndex: 1,
              }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th style={{ whiteSpace: "nowrap" }}>Sr. No</th>
                <th style={{ whiteSpace: "nowrap" }}>SO No</th>
                <th style={{ whiteSpace: "nowrap" }}>Item Code</th>
                <th style={{ whiteSpace: "nowrap" }}>Order Date</th>

                <th style={{ whiteSpace: "nowrap" }}>Order QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Invoice QTY</th>

                <th style={{ whiteSpace: "nowrap" }}>Inward QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Outward QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>Installation QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Installation Claimed QTY
                </th>
                <th style={{ whiteSpace: "nowrap" }}>Installation Paid QTY</th>

                <th style={{ whiteSpace: "nowrap" }}>Commissioning QTY</th>
                <th style={{ whiteSpace: "nowrap" }}>
                  Commissioning Claimed QTY
                </th>
                <th style={{ whiteSpace: "nowrap" }}>Commissioning Paid QTY</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    <Spinner color="primary" />
                  </td>
                </tr>
              ) : Object.values(groupedItems).length > 0 ? (
                Object.values(groupedItems)?.map((group, index) => (
                  <React.Fragment key={group.makeItem.unique_id}>
                    {group.makeItem.type == 1 && (
                      <tr
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#f0f8ff",
                        }}
                      >
                        <td>{serialNumber++}</td>
                        <td style={{ minWidth: "150px" }}>
                          {group.makeItem.order_no}
                        </td>
                        <td
                          style={{
                            paddingLeft: "10px",
                            paddingRight: "2px",
                            minWidth: "180px",
                          }}
                        >
                          <div
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                            }}
                            title={group.makeItem.item_code || "N/A"}
                          >
                            {group?.makeItem?.item_code || "N/A"}
                          </div>
                        </td>{" "}
                        <td>{formatDate(group.makeItem.order_date)}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                        <td>{"-"}</td>
                      </tr>
                    )}

                    {group?.buyItems
                      ?.filter((item) => item.type == 1 || item.type == 2)
                      ?.map((row, subIndex) => (
                        <tr
                          key={row.unique_id}
                          style={{
                            borderBottom: "1px solid #ccc",
                          }}
                        >
                          <td>
                            {row.type == 1
                              ? `${serialNumber - 1}.${subIndex + 1}`
                              : serialNumber++}
                          </td>
                          {/* <td></td> */}
                          <td style={{ minWidth: "150px" }}>
                            {row?.order_no || "N/A"}
                          </td>
                          <td
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "2px",
                              minWidth: "180px",
                            }}
                          >
                            <div
                              style={{
                                display: "-webkit-box",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "normal",
                              }}
                              title={row?.buy_item_code || "N/A"}
                            >
                              {row?.buy_item_code || "N/A"}
                            </div>
                          </td>{" "}
                          <td style={{ minWidth: "150px" }}>
                            {formatDate(row?.order_date) || "N/A"}
                          </td>
                          <td>{formatNumber(row?.order_qty)}</td>
                          <td>{formatNumber(row?.invoice_qty)}</td>
                          <td>{formatNumber(row?.inward_qty)}</td>
                          <td>{formatNumber(row?.outward_qty)}</td>
                          <td>{formatNumber(row?.installation_qty)}</td>
                          <td>{formatNumber(row?.installation_claimed_qty)}</td>
                          <td>{formatNumber(row?.installation_paid_qty)}</td>
                          <td>{formatNumber(row?.commission_qty)}</td>
                          <td>{formatNumber(row?.commissioning_claim_qty)}</td>
                          <td>{formatNumber(row?.commissioning_paid_qty)}</td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))
              ) : (
                <>
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      No. data available.
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </Row>
    </CustomForm>
  );
};

export default OrderTracking;
